<template>
    <el-dialog
        width="900px"
        title="车辆改派记录"
        :visible="visible"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose">
            <el-table :data="recordList" border class="task-list" width="100%" >
                <el-table-column prop="beforeContent" label="改派前" min-width="200px" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="afterContent" label="改派后" min-width="200px" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="createUserName" label="操作人" min-width="170px" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="onthewayFlagName" label="是否在途修改" min-width="100px" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="updateTime" label="操作时间" min-width="190px" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="beforeClose">确 定</el-button>
            </span>
    </el-dialog>
</template>

<script>
import { queryVehicleRecord } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
export default {
    name: 'DispatchVehicleRecord',
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            visible: false,
            recordList: []
        };
    },
    async mounted () {
        await this.queryRecord();
        this.visible = true;
    },
    methods: {
        // 关闭
        beforeClose () {
            this.$emit('components-close');
        },
        /**
         * @description 查询运费修改日志
         */
        queryRecord () {
            return queryVehicleRecord(this.componentsData.dispatchNo).then(res => {
                if (res && +res.code === 0) {
                    this.recordList = this.formatData(res.data || []);
                }
            });
        },
        /**
         * @description 处理列表数据
         */
        formatData (data) {
            if (!data.length) return [];
            data.forEach(item => {
                item.beforeContent = (item.beforeVehicleCard || '') + '/' + (item.beforeDriver || '');
                item.afterContent = (item.vehicleCard || '') + '/' + (item.driver || '');
                item.onthewayFlagName = +item.onthewayFlag === 1 ? '是' : '否';
            });
            return data;
        }
    }
};
</script>
